// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"362":"a5b73316","552":"baa860bb","791":"f4d8e11e","953":"70341b6b","971":"bad138bc"}[chunkId] + ".css";
};